import React, { useCallback } from 'react';

import uuid from 'uuid/v4';

import { type SmartCardProvider as DefaultSmartCardProvider } from '@atlaskit/link-provider';
import { adfToMarkdownPlus } from '@atlassian/adf-markdown-transformer';
import {
	type ObjectExamplesConfig,
	SmartCreatePrompt as SmartCreatePromptPlatform,
	useSmartStore,
} from '@atlassian/smart-create';

// import { useSmartCreateChatActions } from './store/SmartCreateChatStore';

type ErrorBoundaryProps = {
	children: React.ReactNode;
};

type SmartCreatePromptProps = {
	spaceKey: string;
	SmartCardProvider?: typeof DefaultSmartCardProvider;
	ErrorBoundary?: React.ComponentType<ErrorBoundaryProps>;
	onNavigate: (conversationId: string) => void;
	examples?: ObjectExamplesConfig;
};

export const SmartCreatePrompt = ({
	spaceKey,
	SmartCardProvider,
	ErrorBoundary,
	onNavigate,
	examples,
}: SmartCreatePromptProps) => {
	const { prompt } = useSmartStore();
	// const { setPendingPrompt, initializeChat } = useSmartCreateChatActions();

	const navigateToChat = useCallback(
		(prompt: string) => {
			if (!prompt.trim()) {
				return;
			}

			// TODO: This is dependent on how we end up managing state
			// Initialize chat with user message
			// initializeChat([
			// 	{
			// 		id: `msg_${Date.now()}_user`,
			// 		content: prompt, // Prompt passed in as stringified ADF
			// 		sender: 'user',
			// 		timestamp: new Date(),
			// 		status: 'complete',
			// 	},
			// ]);

			// Navigate to session
			// TODO: Get the actual conversationId from Rovo once it's hooked up
			const conversationId = uuid();
			onNavigate(conversationId);
		},
		[onNavigate],
	);

	const handleCreateContent = useCallback(async (): Promise<void> => {
		// Convert ADF prompt to markdown
		const { markdown: promptMarkdown } = adfToMarkdownPlus(JSON.parse(prompt));

		// Store the prompt in the chat store for the session to pick up
		const spaceName = spaceKey; // TODO: FIX THIS
		// setPendingPrompt(spaceName, promptMarkdown);

		// eslint-disable-next-line no-console
		console.log('smart-create ->🎯 SmartCreatePrompt storing pending prompt:', {
			spaceName,
			promptMarkdown,
		});

		// Navigate to session - the session will auto-start streaming
		navigateToChat(promptMarkdown);
	}, [navigateToChat, prompt, spaceKey]);

	return (
		<SmartCreatePromptPlatform
			handleCreateContent={handleCreateContent}
			ErrorBoundary={ErrorBoundary}
			SmartCardProvider={SmartCardProvider}
			examples={examples}
		/>
	);
};
